import axios from "axios";
import { reportApiError } from "./errorReporter";

const api = axios.create({
  baseURL: `${process.env.REACT_APP_BACKEND_URL}/api`,
  withCredentials: true,
});

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("atlas_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  // dispositivo affidabile: salta l'SMS di conferma ordine per 30 giorni
  const td = localStorage.getItem("simamma_td");
  if (td) config.headers["X-Trusted-Device"] = td;
  return config;
});

api.interceptors.response.use(
  (res) => res,
  (err) => {
    const status = err.response?.status;
    if (status && status >= 500) {
      reportApiError(err.config, status, err.response?.data?.detail || err.message);
    }
    return Promise.reject(err);
  }
);

export default api;
